export default "__VITE_ASSET__0_tmM9r0__"